<template>
  <div class="notify-body-wrap">
    <!-- 通知栏 start -->
    <div class="notify-body"
      v-if="this.status">
      <div class="icon"></div>

      <div id="scroll_div"
        @click.stop="showAlert()">
        <div id="scroll_begin"
          :class="isAndroid()?'exclusiveForAndroid':''"> {{this.content}} <span style="padding-right: 2em"> </span></div>
        <div id="scroll_end"
          :class="isAndroid()?'exclusiveForAndroid':''"></div>
      </div>

      <div class="close"
        @click.stop="close()">×</div>
    </div>
    <!-- 通知栏 end -->

    <!-- 弹窗 start -->
    <div v-if="this.status"
      class="popup"
      :class="{'popup-show' : popup }">
      <div class="top"><span>通知</span> <i @click="closePopup"></i></div>
      <div class="popup-content">
        <div>{{content}}</div>
      </div>
    </div>
    <div class="overflow"
      :class="{'overflow-show' : popup }"
      @click="closePopup"></div>
    <!-- 弹窗 end -->
  </div>
</template>

<script>
import { getBroswerUA } from '../../assets/js/util.js'

export default {
  name: 'Notify',
  props: {
    status: {
      type: Boolean,
      default: false
    },
    content: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      timer: null,
      popup: false
    }
  },
  methods: {
    close () {
      this.$emit('update:status', false)
    },
    showAlert () {
      this.popup = true
    },
    closePopup () {
      this.popup = false
    },
    scrollLeft () {
      let speed = 50
      let scroll_begin = document.getElementById('scroll_begin')
      let scroll_end = document.getElementById('scroll_end')
      let scroll_div = document.getElementById('scroll_div')
      if (scroll_begin.offsetWidth < scroll_div.offsetWidth) {
        return
      }
      scroll_end.innerHTML = scroll_begin.innerHTML
      function Marquee () {
        if (scroll_end.offsetWidth - scroll_div.scrollLeft <= 0) {
          scroll_div.scrollLeft -= scroll_begin.offsetWidth
        } else {
          scroll_div.scrollLeft++
        }
      }
      this.timer = setInterval(Marquee, speed)
    },
    isAndroid () {
      return getBroswerUA() === 'Android'
    }
  },
  mounted () {
    if (this.status) {
      this.scrollLeft()
    }
  },
  destroyed () {
    this.timer = null
  }
}
</script>

<style scoped lang='less'>
@image: "../../assets/images/";

.notify-body-wrap {
  position: relative;
}
.notify-body {
  width: 100%;
  height: 70/200rem;
  line-height: 70/200rem;
  font-size: 26/200rem;
  font-weight: 400;
  color: rgba(236, 115, 7, 1);
  background: rgba(253, 250, 229, 1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;

  .icon {
    width: 68/200rem;
    height: 100%;
    background: url("@{image}voice.png") no-repeat center;
    background-size: 26/200rem 26/200rem;
    vertical-align: middle;
  }

  #scroll_div {
    flex: 1;
    height: 100%;
    overflow: hidden;
    white-space: nowrap;
    // 解决安卓字体对齐问题
    .exclusiveForAndroid {
      line-height: 0.365rem;
    }
    #scroll_begin,
    #scroll_end {
      display: inline;
    }
  }
  .close {
    width: 80/200rem;
    height: 100%;
    text-align: center;
    font-size: 40/200rem;
  }
}
.popup {
  z-index: 51;
  background-color: #fff;
  border-radius: 8/200rem;
  overflow: hidden;
  position: fixed;
  top: 50%;
  left: 50%;
  bottom: auto;
  right: auto;
  width: 580/200rem;
  margin-top: -400/400rem;
  margin-left: -580/400rem;
  transform: scale3d(0, 0, 0);
  transition: transform 0.3s;

  .top {
    display: flex;
    height: 77/200rem;
    justify-content: space-between;
    align-items: center;
    background: rgba(242, 242, 247, 1);
    padding: 0 20/200rem 0 30/200rem;
    span {
      display: inline-block;
      max-width: 480/200rem;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 32/200rem;
      color: rgba(46, 46, 46, 1);
    }
    i {
      width: 36/200rem;
      height: 36/200rem;
      background-image: url("@{image}apply/close.png");
      background-size: cover;
    }
  }
  .popup-content {
    max-height: 300/200rem;
    padding: 40/200rem 30/200rem;
    line-height: 1.5;
    align-items: center;
    justify-content: center;
    font-size: 26/200rem;
    overflow: scroll;
    background-color: #fff;
  }
}
.popup-show {
  transform: scale3d(1, 1, 1);
}
.overflow {
  position: fixed;
  height: 100%;
  width: 100%;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 50;
  transition: opacity 0.2s;
  opacity: 0;
  transform: scale(0);
}
.overflow-show {
  opacity: 1;
  transform: scale(1);
}
</style>
